import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AboutRoutingModule } from './about-routing.module';
import { AboutComponent } from './about.component';
import { AuthModule } from '@app/core/auth';

@NgModule({
  imports: [CommonModule, TranslateModule, AboutRoutingModule, AuthModule],
  declarations: [AboutComponent]
})
export class AboutModule {}
